module.exports = "<div class=row> <div class=col-xs-12> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.onSave() ng-disabled=\"!$ctrl.saveEnabled || !$ctrl.updatePermission\" translate> Save </button> <button type=button class=\"btn btn-default\" ng-click=$ctrl.onCancel() translate> Cancel </button> <span ng-if=!$ctrl.updatePermission translate class=inline-error> You do not have the right to modify this object. </span> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/savecancel/partial.html
// module id = 557
// module chunks = 0